'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageUpload = function (_Component) {
  (0, _inherits3.default)(ImageUpload, _Component);

  function ImageUpload(props) {
    (0, _classCallCheck3.default)(this, ImageUpload);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImageUpload.__proto__ || (0, _getPrototypeOf2.default)(ImageUpload)).call(this, props));

    _this.state = {
      file: '',
      imagePreviewUrl: _this.props.src
    };
    _this._handleImageChange = _this._handleImageChange.bind(_this);
    _this._handleSubmit = _this._handleSubmit.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ImageUpload, [{
    key: '_handleSubmit',
    value: function _handleSubmit(e) {
      e.preventDefault();
      // TODO: do something with -> this.state.file
    }
  }, {
    key: '_handleImageChange',
    value: function _handleImageChange(e) {
      var _this2 = this;

      e.preventDefault();

      var reader = new FileReader();
      var file = e.target.files[0];
      var data;

      reader.onloadend = function () {
        data = reader.result;
        _this2.setState({
          file: file,
          imagePreviewUrl: data
        });
        console.log(data);

        _this2.props.handleChange(data);
      };

      console.log(data);
      reader.readAsDataURL(file);
      console.log(data);
      //this.props.handleChange(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var imagePreviewUrl = this.state.imagePreviewUrl;

      var $imagePreview = null;
      if (imagePreviewUrl) {
        $imagePreview = _react2.default.createElement('img', { src: imagePreviewUrl });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'form',
          { onSubmit: this._handleSubmit },
          _react2.default.createElement('input', { type: 'file', onChange: this._handleImageChange }),
          _react2.default.createElement(
            'button',
            { type: 'submit', onClick: this._handleSubmit },
            'Upload Image'
          )
        ),
        $imagePreview
      );
    }
  }]);
  return ImageUpload;
}(_react.Component);

exports.default = ImageUpload;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageUpload/ImageUpload.js
// module id = 1737
// module chunks = 0